"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeDeepRight = void 0;
var ramda_1 = require("ramda");
var mergeDeepRight = function (left, right) {
    return ramda_1.mergeDeepRight(left, right ? right : {});
};
exports.mergeDeepRight = mergeDeepRight;
//# sourceMappingURL=merge-deep-right.js.map